const strings = {
  'username/sectionBanner/text': {
    en: 'DISPLAY NAME CREATION',
    fr: 'CRÉATION D’UN NOM D’UTILISATEUR',
  },
  'username/header/text': {
    en: 'Create your display name for the NHL Hockey Challenge<sup>TM</sup> Leaderboard',
    fr: 'Choisissez un nom d’utilisateur pour le classement du Défi de hockey de la LNH',
  },
  'username/blurb/text': {
    en: `This year, your display name will be used as your identifier in the leaderboard.`,
    fr: `Nouveauté cette année : votre nom d’utilisateur sera celui utilisé pour vous identifier dans le classement.`,
  },
  'username/saveButton/text': {
    en: `Save`,
    fr: `Enregistrer`,
  },
  'username/usernameLengthError/text': {
    en: `Please enter a name between 3-15 characters, using only letters, numbers or underscores (_).`,
    fr: `Veuillez saisir un nom qui comprend de 3 à 15 caractères, en utilisant uniquement des lettres, des chiffres ou des traits de soulignement (_).`,
  },
  'username/boomError/text': {
    en: (code) => {
      switch (code) {
        case 'hc.40':
          return 'Please enter an appropriate display name.';
        case 'hc.41':
          return 'That name is already in use. Please enter a different name.';
        default:
          return 'Error';
      }
    },
    fr: (code) => {
      switch (code) {
        case 'hc.40':
          return 'Veuillez saisir un nom d’utilisateur approprié.';
        case 'hc.41':
          return 'Ce nom d’utilisateur est déjà utilisé. Veuillez saisir un nom d’utilisateur différent.';
        default:
          return 'Error';
      }
    },
  },
  'success/header/text': {
    en: "Lace your skates up, you're ready to play!",
    fr: 'Attachez vos patins, c’est l’heure de jouer!',
  },
  'success/button/text': {
    en: "Let's play",
    fr: 'Jouer',
  },
  'success/blurb/text': {
    en: 'You can start by selecting players for the first game day.',
    fr: 'Commencez par sélectionner des joueurs pour le premier jour de match.',
  },
  'success/logo/src': {
    en: '2025_tnhc_svg_en.svg',
    fr: '2025_tnhc_svg_fr.svg',
  },
  'update/username/heading': {
    en: 'Display name',
    fr: "Nom d'affichage",
  },
  'update/username/buttonText': {
    en: 'Update',
    fr: 'Mise à jour',
  },
  'update/username/success': {
    en: 'Display Name has been updated. You should see the change within the next 24 hours.',
    fr: 'Le nom d’affichage a été mis à jour. Vous devriez voir le changement dans les prochaines 24 heures.',
  },
};

export default strings;
